import axios from "axios";

/**
 * RAG-40 — Indicateurs de synchronisation du tableau de bord.
 *   - GET admins/dashboard/sync : agrégats en base (un seul appel)
 *   - GET health/check          : état des connecteurs (probe live, séparé)
 */

export interface SyncDashboard {
  products_by_source: { socoda: number; interactiv: number; plateforme: number; csv: number };
  suppliers_without_rule: number;
  pending_category_mappings: number;
  pending_brand_mappings: number;
  sync_errors_24h: number;
  last_syncs: { name: string; status: string; ended_at: string | null; duration_seconds: number | null }[];
}

function getSync(): Promise<SyncDashboard | null> {
  return axios
    .get(`${process.env.REACT_APP_API_URL}admins/dashboard/sync`)
    .then((response) => response.data)
    .catch(() => null);
}

/**
 * RAG-67 — Rapport de santé complet. `status` = critique plateforme (base de données +
 * disque) uniquement ; `services` = santé de chaque connecteur tiers (true = répond).
 * Le tableau de bord doit s'appuyer sur `services`/`errors` pour dire QUEL connecteur
 * est en problème (et pas seulement sur `status`, qui ne parle pas des connecteurs).
 */
export interface HealthReport {
  status: boolean;
  // Un connecteur vaut true (répond), false (en panne) ou null (volontairement non
  // configuré, ex. Plateforme Socoda en sommeil) — null ne compte pas comme une panne.
  services: Record<string, boolean | null>;
  errors?: Record<string, string>;
}

function getHealth(): Promise<HealthReport | null> {
  return axios
    .get(`${process.env.REACT_APP_API_URL}health/check`, { timeout: 8000 })
    .then((response) => response.data)
    .catch(() => null);
}

export default {
  getSync,
  getHealth,
};
